import ko from "knockout";
import { map, max } from "lodash";
import ViewModel from "viewModels/ViewModel";

const PercentGraphView = ViewModel.extend(function (percentData) {
    const self = this;

    const estimatedWidthPerCharacter = 8; // px
    const fourDigitPercentageWidth = 46; // px

    self.getDurationPercentages = function () {
        return map(percentData(), function (row) {
            if (!row.label || row.label.length === 0) {
                row.label = self.formatPercentage(row.percent());
            }
            if (!row.labelAriaLabel || row.labelAriaLabel.length === 0) {
                row.labelAriaLabel = row.label;
            }
            return row;
        });
    };

    self.formatPercentage = function (percent) {
        return ko.i18n.formatNumber(percent / 100, {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };

    self.maxPercent = ko.computed(() =>
        max([...map(percentData(), (a) => a.percent()), 0])
    );

    self.maxTextGroupWidth = ko.computed(function () {
        // best effort to estimate how long the width is going to be
        const maxCharLength = max(
            map(percentData(), (a) =>
                a.label
                    ? a.label.length * estimatedWidthPerCharacter
                    : fourDigitPercentageWidth
            )
        );
        return maxCharLength + "px";
    });
});

export default PercentGraphView;
